// @flow

import { useState } from 'react';
import { type PlaceOrderErrorPayload } from '@tectonics/prs/outgoing-payment';

export function useSubmitError(): [?PlaceOrderErrorPayload, (?PlaceOrderErrorPayload) => void] {
  const [
    submitError,
    setSubmitError,
  ] = useState<?PlaceOrderErrorPayload>(null);

  return [submitError, setSubmitError];
}
